import React, { Component }  from 'react'
import { Modal, Statistic, Image, Table, Label, Confirm, Input } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'

const _ = {
  find: find,
  isEmpty: isEmpty
}

class ToDoModal extends Component {
  state = {
    searchKey: ''
  };

  isSearched = (searchKey) => {
    return function(item) {
      return (
        !searchKey ||
        item.section.name.toLowerCase().includes(searchKey.toLowerCase()) ||
        item.section.gradeLevel.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange = (event) => {
    this.setState({ searchKey: event.target.value });
  }

  render() {
    const {data, value, sectionSubjects, title, quarter} = this.props;

    // Add null check to prevent crashes during loading
    if (!sectionSubjects || !Array.isArray(sectionSubjects)) {
      return null; // Don't render anything if data isn't ready
    }

    const currentSectionSubjects = sectionSubjects.filter(this.isSearched(this.state.searchKey));
    const headers = (
      <Table.Row>
        <Table.HeaderCell textAlign='center'>
          Subject
        </Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>
          Section
        </Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>
          Teacher
        </Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>
          Action
        </Table.HeaderCell>
      </Table.Row>
    )

    const body = data.map((item, key )=> {
      if(_.isEmpty(sectionSubjects) ) return null;

      const sectionSubject = _.find(currentSectionSubjects, {
        sectionSubjectId: item.sectionSubjectId
      });
      if (sectionSubject != null) {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{sectionSubject.subject.name}</Table.Cell>
            <Table.Cell>{sectionSubject.section.gradeLevel} - {sectionSubject.section.name}</Table.Cell>
            <Table.Cell>{sectionSubject.teacher.firstName} {sectionSubject.teacher.lastName}</Table.Cell>
            {
              this.props.title === 'My Subjects' ?
              <Table.Cell collapsing>
                {
                  this.props.isGrades ?
                  <NavLink to={`/grades/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
                    <Label as='a' content='To Do' icon='pin' color='blue'/>
                  </NavLink> :
                  <NavLink to={`/conducts/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
                    <Label as='a' content='To Do' icon='pin' color='blue'/>
                  </NavLink>
                }


              </Table.Cell> :
              <Table.Cell collapsing>
                {
                  this.props.isGrades ?
                  <Label as='a' content='Notify' icon='bell' color='red' onClick={
                      () => this.props.openConfirmation(`/grades/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=${quarter}`,sectionSubject.teacher.teacherId)
                  }/> :
                  <Label as='a' content='Notify' icon='bell' color='red' onClick={
                      () => this.props.openConfirmation(`/conducts/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=${quarter}`,sectionSubject.teacher.teacherId)
                  }/>
                }
                </Table.Cell>
            }
          </Table.Row>
        );
      } else {
        return null;
      }

    });

    return (
      <Modal trigger={
        <Statistic className='to-do'>
          <Statistic.Value>
            <span className='stat-value'>{value}</span>
            <Image src='dashboard/ToDo.png' inline />
          </Statistic.Value>
          <Statistic.Label className='stat-label'>To Do</Statistic.Label>
        </Statistic>
      } closeIcon>
      <Modal.Header>{title}
        <Label className='to-do-label' horizontal>
          TO DO
        </Label>
      </Modal.Header>
        <Modal.Content>
          <Input
            fluid
            icon='search'
            value={this.state.searchKey}
            onChange={this.onSearchChange}
            placeholder='Search Sections'
          />
          {
            data.length > 0 ?
            <Table celled striped size='small'>
              <Table.Header>
                {headers}
              </Table.Header>
              <Table.Body>{body}</Table.Body>
            </Table> :
            <h3>Nothing to do here.</h3>
          }

        </Modal.Content>
        <Modal.Actions>
          <Confirm
            size='tiny'
            open={this.props.openConfirm}
            onCancel={this.props.closeConfirmation}
            onConfirm={this.props.handleNotify}
          />
        </Modal.Actions>
      </Modal>
    )
  }
};

export default ToDoModal;
